export const DEFAULT_PAGE_SIZES = [5, 10, 25, 50];
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_MAX_HEIGHT = '70vh';
